import React from "react";
import mountain from "../img/mountain.webp";
import "./Page.css";

const MountainBreak = () => (
  <section id="mountainBreakContainer">
    <div className="section-inner">
      <div className="mountain-break-frame">
        <img src={mountain} alt="Mountain" />
      </div>
    </div>
  </section>
);

export default MountainBreak;
